import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllTestimonials } from "store/getTestimonialSlice";
import { createTestimonial } from "store/testimonialSlice";
import { updateTestimonial } from "store/testimonialUpdateSlice";
import TestimonialTableDropdown from "components/Dropdowns/TestimonialTableDropdown";

export default function TestimonialTable({ color }) {
  const dispatch = useDispatch();
  const { data: testimonial, loading, error } = useSelector(
    (state) => state.alltestimonials
  );

  const [showModal, setShowModal] = useState(false);
   const [editId, setEditId] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    country: "",
    position: "",
    description: "",
    rating: 0,
  });

  useEffect(() => {
    dispatch(fetchAllTestimonials());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // dispatch(createTestimonial(formData)).then(() => {
    //   setShowModal(false);
    //   setFormData({ name: "", country: "", position: "", description: "", rating: 0 });
    //   dispatch(fetchAllTestimonials());
    // });
     if (editId) {
      dispatch(updateTestimonial({ id: editId, updatedData: formData })).then(() => {
        closeModal();
        dispatch(fetchAllTestimonials());
      });
    } else {
      dispatch(createTestimonial(formData)).then(() => {
        closeModal();
        dispatch(fetchAllTestimonials());
      });
    }
  };

  const handleEdit = (testimonial) => {
    setFormData({
      name: testimonial.name,
      country: testimonial.country,
      position: testimonial.position,
      description: testimonial.description,
      rating: testimonial.rating,
    });
    setEditId(testimonial._id);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditId(null);
    setFormData({ name: "", country: "", position: "", description: "", rating: 0 });
  };

  return (
    <>
      {/* Modal Form */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
            <h3 className="text-xl font-bold mb-4">{editId ? "Edit Testimonial" : "Add New Testimonial"}</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                type="text"
                name="name"
                placeholder="Name"
                required
                value={formData.name}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />
              <input
                type="text"
                name="country"
                placeholder="Country"
                required
                value={formData.country}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />
              <input
                type="text"
                name="position"
                placeholder="Position"
                required
                value={formData.position}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />
              <textarea
                name="description"
                placeholder="Description"
                required
                value={formData.description}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />
              <input
                type="number"
                name="rating"
                placeholder="Rating (1-5)"
                min="1"
                max="5"
                required
                value={formData.rating}
                onChange={handleChange}
                className="w-full border px-3 py-2 rounded"
              />
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={closeModal}
                  // onClick={() => setShowModal(false)}
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Table Section */}
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center justify-between">
            <h3
              className={
                "font-semibold text-lg " +
                (color === "light"
                  ? "text-blueGray-700"
                  : "text-white")
              }
            >
              Testimonial Table
            </h3>
            <button
              onClick={() => setShowModal(true)}
              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
              type="button"
            >
              + Add New
            </button>
          </div>
        </div>

        <div className="block w-full overflow-x-auto">
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                {["Name", "Country", "Description", "Position", "Rating", ""].map(
                  (heading, idx) => (
                    <th
                      key={idx}
                      className={`px-6 py-3 text-xs uppercase font-semibold text-left ${
                        color === "light"
                          ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                          : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700"
                      }`}
                    >
                      {heading}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" className="text-center p-4">
                    Loading...
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="10" className="text-center p-4 text-red-500">
                    {error}
                  </td>
                </tr>
              ) : testimonial.length === 0 ? (
                <tr>
                  <td colSpan="10" className="text-center p-4">
                    No testimonial found.
                  </td>
                </tr>
              ) : (
                testimonial.map((item) => (
                  <tr key={item._id}>
                    <td className="px-6 py-3 text-sm">{item.name}</td>
                    <td className="px-6 py-3 text-sm">{item.country}</td>
                    <td className="px-6 py-3 text-sm">{item.description}</td>
                    <td className="px-6 py-3 text-sm">{item.position}</td>
                    <td className="px-6 py-3 text-sm">{item.rating}</td>
                    <td className="px-6 py-3 text-sm text-right">
                      <TestimonialTableDropdown testimonial={item} onEdit={handleEdit}/>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

TestimonialTable.defaultProps = {
  color: "light",
};

TestimonialTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
